import { lockScrollPage } from '../helpers/lockPage';

const modalsBtnOpen = document.querySelectorAll('[data-modal]');

if (modalsBtnOpen) {
  modalsBtnOpen.forEach((btn) => {
    btn.addEventListener('click', (event) => {
      event.preventDefault();
      const modalName = btn.getAttribute('data-modal');
      const params = {};

      Array.from(btn.attributes).forEach(attr => {
        if (attr.name.startsWith('data-modal-param-')) {
          const key = attr.name.replace('data-modal-param-', '');
          params[key] = attr.value;
        }
      });

      ModalHandler(modalName, params);
    });
  });
}

export function showModal(dialog) {
  const closeBtns = dialog.querySelectorAll('[data-modal-close]');

  lockScrollPage(true);
  dialog.showModal();

  closeBtns.forEach(btn => btn.onclick = (event) => {
    event.preventDefault();
    closeDialog(dialog);
  });

  dialog.onclick = ({ target: dialog }) => {
    if (dialog.nodeName === 'DIALOG') {
      closeDialog(dialog)
    }
  }

  const onEscPress = (event) => {
    if (event.key === 'Escape') {
      lockScrollPage(false);

      document.removeEventListener('keydown', onEscPress);
    }
  };

  document.addEventListener('keydown', onEscPress);
}

export function closeDialog(dialog) {
  const component = dialog.querySelector('[x-data]');

  if (component && component._x_dataStack) {
    const dataStack = component._x_dataStack;
    const form = dataStack[0]?.form;

    if (form && form._original) {
      Object.assign(form, form._original);
      delete form._original;
    }

    if ('errors' in dataStack[0]) {
      dataStack[0].errors = {};
    }
  }

  dialog.close('dismiss');
  lockScrollPage(false);
}

export function ModalHandler(name, params = {}) {
  const modalName = name.indexOf('#') !== -1 ? name : `#${name}`;
  const modal = document.querySelector(`${modalName}`);
  const component = modal.querySelector('[x-data]');

  if (component && component._x_dataStack) {
    const dataStack = component._x_dataStack;
    const form = dataStack[0]?.form;

    if (form) {
      if (!form._original) {
        form._original = { ...form };
      }

      for (const key in params) {
        if (form.hasOwnProperty(key)) {
          form[key] = params[key];
        }
      }
    }
  }

  showModal(modal);
}
